import React, { useState } from 'react';
import { useStore } from '../../store/rootStore';
import { updateLocalStorage } from '../../helpers';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import Header from './components/Header';
import Filters from './components/Filters';
import List from './components/List';
import { observer } from 'mobx-react';
import { getReplyTimestamp, isAiQuickReply } from '../../helpers/aiQuickReplies';
import { matchesQuickReplyDepartment, matchesQuickReplySearch } from './helpers';
const QuickReplies = ({ items, onClicked, onClose, loading }) => {
    const [search, setSearch] = useState('');
    const [department, setDepartment] = useState(localStorage.getItem(LOCAL_STORAGE_KEYS.FILTERS.QUICK_REPLIES_DEPARTMENTS_FILTER) || null);
    const { departmentsStore, activeChatStore } = useStore();
    const onDepartmentChanged = (value) => {
        setDepartment(value);
        updateLocalStorage(LOCAL_STORAGE_KEYS.FILTERS.QUICK_REPLIES_DEPARTMENTS_FILTER, value);
    };
    function getFilteredQuickReplies() {
        return items
            .filter((reply) => {
            var _a;
            // Channel filter
            if (!((_a = activeChatStore.chat) === null || _a === void 0 ? void 0 : _a.channelInfo))
                return false;
            const currentChannelInfo = activeChatStore.chat.channelInfo;
            const chatId = activeChatStore.chat._id;
            const targetMatch = reply.send.target.some((target) => target.name === currentChannelInfo.name
                && target.accountId === currentChannelInfo.accountId
                && (!target.id || target.id === chatId));
            if (!targetMatch)
                return false;
            return matchesQuickReplyDepartment(reply, department) && matchesQuickReplySearch(reply, search);
        })
            .sort((a, b) => {
            const aAi = isAiQuickReply(a) ? 1 : 0;
            const bAi = isAiQuickReply(b) ? 1 : 0;
            if (aAi !== bAi)
                return bAi - aAi;
            return getReplyTimestamp(b) - getReplyTimestamp(a);
        });
    }
    return (React.createElement("div", null,
        React.createElement(Header, { onClose: onClose }),
        React.createElement(Filters, { search: search, onSearchChanged: setSearch, department: department, onDepartmentChanged: onDepartmentChanged, loading: loading }),
        React.createElement(List, { items: getFilteredQuickReplies(), onClicked: onClicked, loading: loading, departmentsList: departmentsStore.departments })));
};
/**
 * QuickReplies Component
 *
 * @description This component is used to display a list of quick replies.
 * It contains a header, filters, and a list of quick replies.
 * @param items - List of quick replies
 * @param loading - Loading state
 * @param onClicked - Function to handle click on a quick reply
 * @param onClose - Function to handle close event
 * @returns JSX.Element
 */
export default observer(QuickReplies);
